<template>
  <div>
    <Breadcrumb msg1="客户管理" msg2="客户档案" />
    <el-card>
      <el-row :gutter="10" style="margin-bottom: 10px">
        <el-col :span="4"><el-input v-model="query.name" placeholder="姓名" clearable></el-input></el-col>
        <el-col :span="4"><el-input v-model="query.phone" placeholder="手机号" clearable></el-input></el-col>
        <el-col :span="4">
          <el-select v-model="query.source" placeholder="来源" clearable>
            <el-option label="自然到店" value="自然到店"></el-option>
            <el-option label="线上预约" value="线上预约"></el-option>
            <el-option label="老客介绍" value="老客介绍"></el-option>
            <el-option label="广告" value="广告"></el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
          <el-button type="success" icon="el-icon-plus" @click="add">新增建档</el-button>
        </el-col>
      </el-row>
      <el-table :data="list" border>
        <el-table-column label="ID" prop="id" width="60"></el-table-column>
        <el-table-column label="档案编号" prop="customerNo" width="120"></el-table-column>
        <el-table-column label="姓名" prop="name" width="100"></el-table-column>
        <el-table-column label="性别" width="60">
          <template slot-scope="scope">{{ scope.row.gender === 1 ? '女' : '男' }}</template>
        </el-table-column>
        <el-table-column label="手机号" prop="phone" width="130"></el-table-column>
        <el-table-column label="年龄" prop="age" width="60"></el-table-column>
        <el-table-column label="来源" prop="source" width="100"></el-table-column>
        <el-table-column label="标签" prop="tags" show-overflow-tooltip></el-table-column>
        <el-table-column label="地址" prop="address" show-overflow-tooltip></el-table-column>
        <el-table-column label="操作" width="260">
          <template slot-scope="scope">
            <el-button size="mini" type="info" @click="view(scope.row.id)">360视图</el-button>
            <el-button size="mini" type="primary" @click="edit(scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="del(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="margin-top: 10px"
        :current-page="query.page"
        :page-sizes="[10, 20, 50]"
        :page-size="query.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="sizeChange"
        @current-change="pageChange"
      ></el-pagination>
    </el-card>

    <el-dialog :title="dialogTitle" :visible.sync="show" width="640px" :close-on-click-modal="false">
      <el-form :model="form" label-width="100px" v-if="show">
        <el-row>
          <el-col :span="12"><el-form-item label="档案编号"><el-input v-model="form.customer_no" placeholder="留空自动生成"></el-input></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="姓名" required><el-input v-model="form.name"></el-input></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="性别">
            <el-radio-group v-model="form.gender"><el-radio :label="0">男</el-radio><el-radio :label="1">女</el-radio></el-radio-group>
          </el-form-item></el-col>
          <el-col :span="12"><el-form-item label="出生日期">
            <el-date-picker v-model="form.birthday" type="date" value-format="yyyy-MM-dd"></el-date-picker>
          </el-form-item></el-col>
          <el-col :span="12"><el-form-item label="年龄"><el-input v-model="form.age" type="number"></el-input></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="手机号" required><el-input v-model="form.phone"></el-input></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="身份证号"><el-input v-model="form.id_card"></el-input></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="来源">
            <el-select v-model="form.source" style="width:100%">
              <el-option label="自然到店" value="自然到店"></el-option>
              <el-option label="线上预约" value="线上预约"></el-option>
              <el-option label="老客介绍" value="老客介绍"></el-option>
              <el-option label="广告" value="广告"></el-option>
            </el-select>
          </el-form-item></el-col>
          <el-col :span="12"><el-form-item label="标签"><el-input v-model="form.tags" placeholder="多个用逗号分隔"></el-input></el-form-item></el-col>
          <el-col :span="24"><el-form-item label="地址"><el-input v-model="form.address"></el-input></el-form-item></el-col>
          <el-col :span="24"><el-form-item label="备注"><el-input v-model="form.remark" type="textarea"></el-input></el-form-item></el-col>
        </el-row>
      </el-form>
      <span slot="footer">
        <el-button @click="show = false">取消</el-button>
        <el-button type="primary" @click="save">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb'
export default {
  components: { Breadcrumb },
  data () {
    return {
      query: { page: 1, limit: 10, name: '', phone: '', source: '' },
      list: [],
      total: 0,
      show: false,
      dialogTitle: '',
      form: {}
    }
  },
  created () { this.getData() },
  methods: {
    getData () {
      this.$axios.get('/customers', res => {
        this.list = res.data.records || []
        this.total = parseInt(res.data.total) || 0
      }, this.query)
    },
    search () { this.query.page = 1; this.getData() },
    sizeChange (s) { this.query.limit = s; this.getData() },
    pageChange (p) { this.query.page = p; this.getData() },
    add () {
      this.dialogTitle = '新增客户档案'
      this.form = { name: '', gender: 0, birthday: '', age: null, phone: '', id_card: '', address: '', source: '自然到店', tags: '', remark: '', customer_no: '' }
      this.show = true
    },
    edit (row) {
      this.dialogTitle = '编辑客户档案'
      this.form = Object.assign({}, row)
      this.show = true
    },
    save () {
      if (!this.form.name || !this.form.phone) {
        this.$message.warning('姓名和手机号必填')
        return
      }
      if (this.form.id) {
        this.$axios.put(`/customers/${this.form.id}`, () => { this.show = false; this.getData() }, this.form)
      } else {
        this.$axios.post('/customers', () => { this.show = false; this.getData() }, this.form)
      }
    },
    del (id) {
      this.$axios.del(`/customers/${id}`, () => { this.getData() })
    },
    view (id) {
      this.$router.push(`/customer/detail/${id}`)
    }
  }
}
</script>
